// extracted by mini-css-extract-plugin
export var active = "_t1-1";
export var circle = "_t1-0";
export var completed = "_t1-2";
export var connector = "_t1-4";
export var connectorCompleted = "_t1-7";
export var connectorSpacer = "_t1-5";
export var iconStrokeOverride = "_t1-8";
export var labelContainer = "_t1-6";
export var pending = "_t1-3";